import React,{useState,useEffect} from 'react';

import DebugService from './services/DebugService';
import I18nService from './services/I18nService';
import ConfigService from './services/ConfigService';
import Service from './services/Service';

import ReactSimpleChatComponent from './components/ReactSimpleChatComponent';



function App(props) {

  const [chatbotEnabled, setChatbotEnabled] = useState(false);

  // get the debug mode
  const myDebugService = DebugService.getInstance();
  const DEBUG = myDebugService.enabled;

  // get the token attribute by props
  const token = props.token;
  // if (DEBUG) console.log('App - props:',{token});

  // i18n service
  const myI18nService = I18nService.getInstance();
  // config service
  const myConfigService = ConfigService.getInstance();

  // api service
  const myService = Service.getInstance();
  myService.setToken(token);

  // ReactSimpleChat steps service
  // const myStepsService = StepsService.getInstance();

  useEffect(() => {
    // a la creation de myService, on check si l'API est up,
    // et on récupere les traductions
    if (!myService.configured) {
      myService.callAPIHello((enabled) => {
        setChatbotEnabled(enabled);
        if (enabled){
          if (!!myService.ui_params) {
            // config
            myConfigService.init(myService.ui_params.input_maxlength);

            // translations
            let resources = {};
            resources[myService.ui_params.locale] = {};
            resources[myService.ui_params.locale].translation = myService.ui_params.labels;
            myI18nService.init(myService.ui_params.locale, resources);

            // globalKey
            myService.generateGlobalKey();
          }
        }
      });
    }
  }, [myService, myI18nService, DEBUG]);

  return (
    <div className="App">
      {chatbotEnabled && myI18nService.initialized ? (
        <ReactSimpleChatComponent />
      ):null}
    </div>
  );
}

export default App;
